import SectionHeader from './SectionHeader';

const REASONS = [
  {
    icon: 'ri-refresh-line',
    title: '疑似违规被批量下架',
    color: 'bg-accent-500',
    desc: '命中高风险特征但证据不充分时，平台倾向先「下架待核」，属可回退处置，配合整改通常能恢复。',
    mark: '多数可申诉回退',
  },
  {
    icon: 'ri-arrow-up-circle-line',
    title: '从整改升级到下架',
    color: 'bg-primary-500',
    desc: '限期整改期内再次违规，或整改后被判定为「改皮不改芯」，会从单条整改升级为下架乃至账号处罚。',
    mark: '升级型连续处置',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '评论区 / 互动连坐',
    color: 'bg-secondary-600',
    desc: '作品合规但评论区或置顶引导持续往越线方向带，平台会按「整体内容环境」评估，主贴连带下架。',
    mark: '环境维度评估',
  },
  {
    icon: 'ri-user-star-line',
    title: '账号维度累计处罚',
    color: 'bg-foreground-950',
    desc: '多次违规被累计到账号维度后，新发内容会进入更高优先级的预审，触发率与下架率同时上升。',
    mark: '预审优先级提高',
  },
];

const COMPARE = [
  { type: '整改', icon: 'ri-tools-line', tone: 'warn', items: ['单条/局部违规', '可修改后重新上架', '记录保留但不直接封号', '处理时效通常较快'] },
  { type: '封禁', icon: 'ri-lock-2-line', tone: 'block', items: ['性质严重或多次累犯', '账号停用，需申诉', '涉及未成年人风险多为直接封', '时间从数日到永久不等'] },
];

export default function RemoveReasons() {
  return (
    <section id="reasons" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="51擦边 · 下架原因"
          title="内容一旦被下架，多半是这四类"
          desc="「为什么偏偏下我这条」的答案，通常藏在处置逻辑里，而不是画面本身。下面四种理由覆盖了绝大多数场景。"
        />

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {REASONS.map((r) => (
            <article key={r.title} className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${r.color} text-background-50`}>
                <i className={`${r.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-serif text-lg font-bold text-foreground-950">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs font-semibold text-foreground-700">
                <i className="ri-price-tag-3-line text-primary-500" />
                {r.mark}
              </span>
            </article>
          ))}
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl border border-background-200 bg-background-50">
          <div className="grid md:grid-cols-2">
            {COMPARE.map((c) => {
              const isWarn = c.tone === 'warn';
              return (
                <div key={c.type} className="p-6 md:p-8">
                  <div className="flex items-center gap-3">
                    <span
                      className={`flex h-10 w-10 items-center justify-center rounded-full ${
                        isWarn ? 'bg-accent-500' : 'bg-foreground-950'
                      } text-background-50`}
                    >
                      <i className={`${c.icon} text-lg`} />
                    </span>
                    <h3 className="font-serif text-xl font-black text-foreground-950">
                      整改 <span className="mx-1 text-background-300">/</span> {c.type}
                    </h3>
                  </div>
                  <ul className="mt-5 space-y-3">
                    {c.items.map((it) => (
                      <li key={it} className="flex items-start gap-2.5 text-sm text-foreground-700">
                        <i className={`mt-0.5 ${isWarn ? 'ri-arrow-right-line text-accent-600' : 'ri-close-circle-line text-primary-600'}`} />
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
          <div className="border-t border-background-200 bg-background-100/60 px-6 py-3.5 text-xs text-foreground-600 md:px-8">
            <i className="ri-information-line mr-1.5 align-middle text-primary-500" />
            想判断自己会被「整改」还是「封禁」，先看是不是第一次、有没有未成年风险、以及互动区是否干净——这三条基本决定了档位。
          </div>
        </div>
      </div>
    </section>
  );
}